class JwtExpiredError extends Error {
  constructor() {
    super(`Jwt Expired Error`);
  }
}

export default JwtExpiredError;
